// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { BuildAssemblyDetail } from './build-assembly-detail';
import { Part } from './part';
import { PartLink } from './part-link';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class BuildAssemblyDetailPart extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  buildAssemblyDetailId!: number;
  created?: Date;
  deleted?: Date;
  partId?: number;
  partLinkId?: number;
  processed?: Date;
  quantity!: number;
  buildAssemblyDetail!: BuildAssemblyDetail;
  part!: Part;
  partLink!: PartLink;
}

